import BaseToggleButton, {
  ButtonProps,
} from "features/CenterContent/shared/Tabs/BaseToggleButton";

const ExpandButton = (props: ButtonProps) =>
  BaseToggleButton({ ...props, toggleType: "expand" });

export default ExpandButton;
